module.exports = __webpack_public_path__ + "img/img6.4fc975b0.png";